"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var ExploreProjects = (function (_super) {
    __extends(ExploreProjects, _super);
    function ExploreProjects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExploreProjects.prototype.render = function () {
        var _a = this.props, getOutputFile = _a.getOutputFile, showChildren = _a.showChildren;
        return (react_1.default.createElement("section", { className: "step explore-projects" },
            react_1.default.createElement("div", { className: "connector-line" }),
            react_1.default.createElement("header", { className: "step-header" },
                react_1.default.createElement("span", { className: "icon icon-search" }),
                react_1.default.createElement("div", { className: "text-content" },
                    react_1.default.createElement("h3", { className: "title" },
                        react_1.default.createElement("span", { className: "step-number" }, "4."),
                        "Explore"),
                    react_1.default.createElement("section", { className: "exports" },
                        react_1.default.createElement("div", { className: "export export-csv" },
                            react_1.default.createElement("div", { className: "description" },
                                react_1.default.createElement("h4", { className: "title" },
                                    react_1.default.createElement("span", { className: "icon icon-grid2" }),
                                    "CSV File"),
                                react_1.default.createElement("p", { className: "subtitle" }, "Grab a copy of the generated data as a CSV file for use in your CRM, sales automation or email marketing tools etc.")),
                            react_1.default.createElement("div", { className: "action" },
                                react_1.default.createElement("button", { className: "secondary-action-button", onClick: getOutputFile }, "Download CSV file"))),
                        react_1.default.createElement("div", { className: "export browse-projects" },
                            react_1.default.createElement("div", { className: "description" },
                                react_1.default.createElement("h4", { className: "title" },
                                    react_1.default.createElement("span", { className: "icon icon-search" }),
                                    "Browse Projects"),
                                react_1.default.createElement("p", { className: "subtitle" }, "Browse a list of \"child\" projects that used this project as a template")),
                            react_1.default.createElement("div", { className: "action" },
                                react_1.default.createElement("button", { className: "secondary-action-button", onClick: showChildren }, "Explore Projects"))))))));
    };
    ExploreProjects = __decorate([
        mobx_react_1.observer
    ], ExploreProjects);
    return ExploreProjects;
}(react_1.default.Component));
exports.default = ExploreProjects;
